"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withIcon = _interopRequireDefault(require("../withIcon"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const IconCamera = props => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  stroke: "currentColor",
  strokeWidth: "2",
  viewBox: "0 0 24 24",
  ...props,
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M23 19a2 2 0 01-2 2H3a2 2 0 01-2-2V8a2 2 0 012-2h4l2-3h6l2 3h4a2 2 0 012 2z"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
    cx: "12",
    cy: "13",
    r: "4"
  })]
});
var _default = exports.default = (0, _withIcon.default)('IconCamera')(IconCamera);